/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2017, 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'bi/glass/app/plugins/MenuActionInterface'
], function(MenuActionInterface) {
	'use strict';

	const ActionHandler = MenuActionInterface.extend({

		actionHandlers: {
			'aboutCognos'(context) {
				const actionId = 'actions.openCognosAnalyticsAboutBox';
				if (context.glassContext.appController.canExecuteAction(actionId, context)) {
					context.glassContext.appController.performAction(actionId, context);
				}
			}
		},

		onSelectItem(context) {
			const key = this._getPluginKey(context.target.itemId);
			const handler = this.actionHandlers[key];
			if (handler) {
				const handle = handler.bind(this, context);
				return handle();
			}
		},

		_getPluginKey(itemId) {
			const idTokens = itemId.split('.');
			return idTokens[idTokens.length - 1];
		}
	});

	return ActionHandler;
});
